export default "__VITE_ASSET__a2e31b4d__"